// Geçmiş sekmesi için örnek veri. Yalnızca geliştirmede: /wsendmessage/history?mock=1 (etiketli liste görünümü: ?mock=merged).
// Üretim derlemesinde hiç devreye girmez.
import _ from 'lodash';
import moment from 'moment';

export function mockMode(location) {
	if (process.env.NODE_ENV === 'production') return null;
	let v = new URLSearchParams((location && location.search) || '').get('mock');
	return v === 'merged' ? 'merged' : v ? 'basic' : null;
}

const NAMES = ['Butik İstanbul', 'Sokak Butik', 'Leila Boutique', 'Dedem Butik Otel', 'Butik Dayı', 'Nu Butik', 'Tuğsem', 'Moda Ala', 'İrma Butik', 'Ayşe Yılmaz', 'Mehmet Demir', 'Zeynep Kaya', 'Can Öztürk', 'Elif Şahin', 'Burak Aydın', 'Selin Arslan', 'Emre Koç', 'Deniz Kurt', 'Hans Müller', 'Anna Schmidt', 'John Smith', 'Fatma Çelik', 'Ali Yıldız', 'Merve Aksoy'];
const TAGS = [
	{ _id: 'tag_vip', title: 'VIP', color: '#6B3FA0' },
	{ _id: 'tag_toptan', title: 'Toptancı', color: '#0B5FA5' },
	{ _id: 'tag_yeni', title: 'Yeni müşteri', color: '#2E9E6B' },
];
// Kampanyalar: mesaj, tip, gün önce, alıcı sayısı, teslim / okunma / hata oranı
const CAMPAIGNS = [
	{ name: 'Ekim indirim duyurusu', message: 'cart_reminder', type: 'template', days: 0, n: 24, del: 0.92, read: 0.71, fail: 0.04, tag: 'tag_vip' },
	{ name: 'Kargo bilgilendirme', message: 'kargo_teslim', type: 'template', days: 1, n: 18, del: 0.95, read: 0.83, fail: 0.0 },
	{ name: 'Yeni sezon', message: 'https://cdn.example.com/yeni-sezon.jpg', text: 'Yeni sezon ürünlerimiz mağazada! *%20 indirim* bu hafta sonu.', type: 'media', days: 2, n: 22, del: 0.8, read: 0.55, fail: 0.12, tag: 'tag_toptan' },
	{ name: 'Hafta sonu kampanyası', message: 'Merhaba, hafta sonuna özel tüm ürünlerde %15 indirim sizi bekliyor.', type: 'text', days: 4, n: 15, del: 0.87, read: 0.6, fail: 0.07 },
	{ name: 'Görüşme onayı', message: 'luvi_gorusme_onayi', type: 'template', days: 7, n: 12, del: 1, read: 0.92, fail: 0 },
	{ name: 'Katalog', message: 'https://cdn.example.com/katalog-2026.pdf', text: 'Güncel kataloğumuz ektedir.', type: 'document', days: 11, n: 20, del: 0.75, read: 0.4, fail: 0.15, tag: 'tag_toptan' },
	{ name: 'Sipariş iptali', message: 'siparis_iptal', type: 'template', days: 15, n: 6, del: 1, read: 1, fail: 0 },
	{ name: 'Web sitemiz yenilendi', message: 'https://www.example.com', text: 'Yeni web sitemize göz atın.', type: 'link', days: 21, n: 24, del: 0.9, read: 0.5, fail: 0.05, tag: 'tag_yeni' },
	{ name: 'Eylül duyurusu', message: 'odeme_bekliyor', type: 'template', days: 34, n: 16, del: 0.88, read: 0.62, fail: 0.06 },
	{ name: 'Açılış daveti', message: 'Mağazamızın açılışına davetlisiniz! Cumartesi 14:00.', type: 'text', days: 48, n: 10, del: 0.7, read: 0.3, fail: 0.2 },
];

function phoneFor(i) {
	if (i === 18) return '4915123456789';
	if (i === 19) return '4917612345678';
	if (i === 20) return '12125550123';
	return '90532' + String(1000000 + i * 37731).slice(-7);
}
const PEOPLE = NAMES.map((name, i) => ({ name, phone: phoneFor(i), tags: i % 3 === 0 ? ['VIP'] : i % 3 === 1 ? ['Toptancı'] : ['Yeni müşteri'] }));

export function mockLogs() {
	return CAMPAIGNS.map((c, ci) => {
		let date = moment().subtract(c.days, 'days').hour(10 + (ci % 6)).minute(ci * 7 % 60).toDate();
		let groups = PEOPLE.slice(0, c.n).map((p) => ({ id: p.phone, name: p.name, phone: 'waba', number: 'waba' }));
		return {
			id: 'mock_' + ci,
			date,
			log: {
				message: c.message,
				text_message: c.text,
				message_type: c.type,
				template_name: c.type === 'template' ? c.message : 'mock_' + ci,
				extra: { message_name: c.name, targetlist: c.tag, hash: 'mock_' + ci, start_time: 1 },
				groups,
			},
		};
	});
}

// broadcastResult biçiminde sonuç: [{ phone_id, cid, status }], durum kademesi read > delivered > sent
export function mockDetails(log) {
	let c = CAMPAIGNS[Number(String(log.extra.hash).replace('mock_', ''))] || CAMPAIGNS[0];
	let n = log.groups.length;
	let failN = Math.round(n * c.fail);
	let deliveredN = Math.round(n * c.del);
	let readN = Math.round(n * c.read);
	let list = [];
	log.groups.forEach((g, i) => {
		if (i >= n - failN) return list.push({ phone_id: g.id + '@c.us', cid: 'c' + i, status: 'failed' });
		let status = i < readN ? 'read' : i < deliveredN ? 'delivered' : 'sent';
		list.push({ phone_id: g.id + '@c.us', cid: 'c' + i, status });
	});
	let replies = log.groups.slice(0, Math.max(1, Math.round(readN / 4))).map((g, i) => ({
		recipient: g.id + '-x',
		recipientName: g.name,
		sendDate: moment().subtract(c.days, 'days').add(1 + i, 'hours').toDate(),
		message: { text: ['Teşekkürler', 'Fiyat nedir?', 'Detay alabilir miyim?', 'İlgilenmiyorum'][i % 4] },
	}));
	return {
		details: list,
		cancel_trigger_count: _.filter(replies, (r) => r.message.text === 'İlgilenmiyorum').length,
		total_message_count: replies.length,
		messages_from_users: replies,
	};
}

export function mockUsers() {
	return PEOPLE.map((p, i) => ({ id: i + 1, name: p.name, phone: p.phone, state: i === 7 ? 'unsubscribe' : 'active', data: { tag: p.tags } }));
}
export const mockTags = TAGS;
